import React from 'react'
import { Link } from "react-router-dom";


const HomeBlog = () => {
    return (
        <>

            <section className="content-inner bg-light overlay-primary-light" style={{ backgroundImage: 'url(images/background/bg6.webp)' }}>
                <div className="container">
                    <div className="section-head style-1 m-b30 row align-items-end">
                        <div className="col-xl-7 col-md-9 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <h2 className="title m-b0 fw-semibold" style={{textAlign:""}}>समाचार और अपडेट </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-md-6 m-b30 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                            <div className="dz-card style-1">
                                <div className="dz-media">
                                    <img src="./assets/img/corona.jpg" alt />
                                </div>
                                <div className="dz-info">
                                    <h3 className="dz-title" style={{ fontSize: '23px' }}><Link to="/blog">कोरोनावायरस के बारे में वो सब कुछ जो आपको जानना चाहिए</Link></h3>
                                    
                                </div>
                                <Link to="/blog" className="btn btn-square btn-secondary rounded-circle">
                                    <i className="feather icon-arrow-up-right" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 m-b30 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
                            <div className="dz-card style-1">
                                <div className="dz-media">
                                    <img src="/assets/img/Coronavirus.webp" alt />
                                </div>
                                <div className="dz-info">
                                    <h3 className="dz-title"><Link to="/blog">कोरोनावायरस संक्रमण को फैलने से कैसे रोकें</Link></h3>
                                    
                                    
                                </div>
                                <Link to="/blog" className="btn btn-square btn-secondary rounded-circle">
                                    <i className="feather icon-arrow-up-right" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 m-b30 wow fadeInUp" data-wow-delay="1.0s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '1s', animationName: 'fadeInUp' }}>
                            <div className="dz-card style-1">
                                <div className="dz-media">
                                    <img src="/assets/img/05.jpg" alt />
                                </div>
                                <div className="dz-info">
                                    <h3 className="dz-title"><Link to="/blog"> प्रमुख न्यूरोलॉजिस्ट: मस्तिष्क और उससे आगे के लिए</Link></h3>
                                    
                                    
                                </div>
                                <Link to="/blog" className="btn btn-square btn-secondary rounded-circle">
                                    <i className="feather icon-arrow-up-right" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeBlog